import { render, staticRenderFns } from "./mobile-header-primary.vue?vue&type=template&id=57b6c164&scoped=true"
import script from "./mobile-header-primary.vue?vue&type=script&lang=js"
export * from "./mobile-header-primary.vue?vue&type=script&lang=js"
import style0 from "./mobile-header-primary.vue?vue&type=style&index=0&id=57b6c164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6c164",
  null
  
)

export default component.exports